<template>
  <svg
    width="22"
    height="22"
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect x="0.5" y="0.5" width="21" height="21" rx="4.5" stroke="#213E7A" />
    <g clip-path="url(#clip0_16135_36302)">
      <path
        d="M16.1266 10.8608C16.1116 10.8268 15.7476 10.0195 14.9385 9.21035C13.8604 8.13227 12.4987 7.5625 11 7.5625C9.50125 7.5625 8.13957 8.13227 7.06148 9.21035C6.25238 10.0195 5.88671 10.8281 5.87339 10.8608C5.85385 10.9047 5.84375 10.9523 5.84375 11.0004C5.84375 11.0485 5.85385 11.0961 5.87339 11.1401C5.88843 11.174 6.25238 11.981 7.06148 12.7901C8.13957 13.8677 9.50125 14.4375 11 14.4375C12.4987 14.4375 13.8604 13.8677 14.9385 12.7901C15.7476 11.981 16.1116 11.174 16.1266 11.1401C16.1461 11.0961 16.1562 11.0485 16.1562 11.0004C16.1562 10.9523 16.1461 10.9047 16.1266 10.8608ZM11 13.75C9.67742 13.75 8.52199 13.2692 7.5655 12.3213C7.17305 11.931 6.83915 11.486 6.57421 11C6.83908 10.514 7.17298 10.0689 7.5655 9.67871C8.52199 8.73082 9.67742 8.25 11 8.25C12.3226 8.25 13.478 8.73082 14.4345 9.67871C14.8277 10.0688 15.1623 10.5139 15.4279 11C15.1181 11.5784 13.7685 13.75 11 13.75ZM11 8.9375C10.5921 8.9375 10.1933 9.05846 9.85413 9.28509C9.51496 9.51172 9.2506 9.83384 9.09449 10.2107C8.93839 10.5876 8.89754 11.0023 8.97713 11.4024C9.05671 11.8025 9.25314 12.17 9.54159 12.4584C9.83003 12.7469 10.1975 12.9433 10.5976 13.0229C10.9977 13.1025 11.4124 13.0616 11.7893 12.9055C12.1662 12.7494 12.4883 12.485 12.7149 12.1459C12.9415 11.8067 13.0625 11.4079 13.0625 11C13.0619 10.4532 12.8444 9.92889 12.4578 9.54222C12.0711 9.15555 11.5468 8.93807 11 8.9375ZM11 12.375C10.728 12.375 10.4622 12.2944 10.2361 12.1433C10.01 11.9922 9.83373 11.7774 9.72966 11.5262C9.62559 11.2749 9.59836 10.9985 9.65142 10.7318C9.70447 10.465 9.83543 10.22 10.0277 10.0277C10.22 9.83543 10.465 9.70447 10.7317 9.65142C10.9985 9.59837 11.2749 9.6256 11.5262 9.72967C11.7774 9.83374 11.9922 10.01 12.1433 10.2361C12.2944 10.4622 12.375 10.7281 12.375 11C12.375 11.3647 12.2301 11.7144 11.9723 11.9723C11.7144 12.2301 11.3647 12.375 11 12.375Z"
        fill="black"
      />
    </g>
    <defs>
      <clipPath id="clip0_16135_36302">
        <rect
          width="11"
          height="11"
          fill="white"
          transform="translate(5.5 5.5)"
        />
      </clipPath>
    </defs>
  </svg>
</template>

<script>
export default {
  name: "IconEye",
};
</script>
